/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Fb_Toast_Arrived_OneInputs */

const en_fb_toast_arrived_one = /** @type {(inputs: Fb_Toast_Arrived_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} sent a point`)
};

const de_fb_toast_arrived_one = /** @type {(inputs: Fb_Toast_Arrived_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} hat einen Punkt geschickt`)
};

/**
* | output |
* | --- |
* | "{name} sent a point" |
*
* @param {Fb_Toast_Arrived_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fb_toast_arrived_one = /** @type {((inputs: Fb_Toast_Arrived_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fb_Toast_Arrived_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_fb_toast_arrived_one(inputs)
	return en_fb_toast_arrived_one(inputs)
});